import React from 'react';
import styles from '../Operations.module.css';

interface MGACComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGAC - Completion
 * KPI information component
 */
const MGAC: MGACComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Completion is a measure of your store&apos;s Count Sheet finalization each month (the number of SKUs present on the Count Sheet to the number with a change to Last Count Date in that same month).
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Mango&apos;s Count Sheets must be processed (SKU physically counted) to report and achieve your operational goals.
        All other Operational and Productivity levels depend on thorough Count Sheet processing.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        95% or higher (3-month average)
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Follow the Ace Way of Retailing <a href="https://acenet.aceservices.com/awor/inventory-record-accuracy/mango-count-sheets" target="_blank" rel="noopener noreferrer" className={styles.link}>Store Procedures</a> to complete Count Sheets monthly by utilizing Eagle/Epicor Mobile + on store-owned devices.
      </div>
    </div>
  );
};

MGAC.title = 'Mango Completion';
MGAC.kpiHyperlink = 'https://mangoreport.com/ol0';
MGAC.actionTitle = 'INVENTORY BOOST TOOL';
MGAC.actionHyperlink = '';
export default MGAC;

